import { useParams } from 'react-router-dom'

import { GetMeetingDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
// eslint-disable-line
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import TalkingPoints from '../../components/TalkingPoints'
import TaskSection from '../../components/TaskSection'

export const OldMeetingShowPage = () => {
  const { employee } = useCurrentSession()
  const param = useParams()

  const { data, loading, error } = useQuery(GetMeetingDocument, {
    variables: { id: Number(param.id || param.meetingId) },
  })
  const meeting = data?.oneOnOnes.meeting

  const { loading: contractVersionsLoading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (loading || contractVersionsLoading) {
    return <Loading />
  }

  if (
    !meeting ||
    !employee ||
    !meeting.oneOnOne.firstParticipant ||
    !meeting.oneOnOne.secondParticipant
  )
    return <NotFound />

  const myTalkingPoint = meeting.talkingPointsConnection.nodes?.find(
    (talkingPoint) => talkingPoint?.owner.id == employee.id
  )
  const otherTalkingPoint = meeting.talkingPointsConnection.nodes?.find(
    (talkingPoint) => talkingPoint?.owner.id !== employee.id
  )

  const isParticipant =
    meeting.oneOnOne.firstParticipant.id === employee.id ||
    meeting.oneOnOne.secondParticipant.id === employee.id

  let myParticipant
  let otherParticipant

  if (meeting.oneOnOne.firstParticipant.id === employee.id) {
    myParticipant = meeting.oneOnOne.firstParticipant
    otherParticipant = meeting.oneOnOne.secondParticipant
  } else {
    myParticipant = meeting.oneOnOne.secondParticipant
    otherParticipant = meeting.oneOnOne.firstParticipant
  }

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      <TalkingPoints
        talkingPoint={myTalkingPoint}
        meetingId={meeting.id}
        participant={myParticipant}
        readOnly={!isParticipant}
        displayBorders={false}
      />
      <TalkingPoints
        talkingPoint={otherTalkingPoint}
        meetingId={meeting.id}
        participant={otherParticipant}
        readOnly
      />
      <TaskSection
        meetingId={meeting.id}
        participantIds={[
          meeting.oneOnOne.firstParticipant.id,
          meeting.oneOnOne.secondParticipant.id,
        ]}
        canAddTask={isParticipant}
        contractVersions={contractVersions}
      />
    </ResponsivePage.Body>
  )
}
